import React, { useState, useEffect } from 'react';
import { Modal, Spin, Row, message, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import Button from '~/components/Button';
import { FaWhatsapp } from 'react-icons/fa';
import { createEvents, getEvents } from '~/services/hooks/events';
import { LuCheck, LuCheckCheck, LuClock } from 'react-icons/lu';
import { SmallTable } from './styles';
import { inviteColumns } from '~/tables/invites';
import errorHandler from '~/Utils/errorHandler';
import Strong from '~/components/Strong';

export default function InviteModal({ visible, event, onClose }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [teamsEmployees, setTeamsEmployees] = useState([]);

  const fetchTeamsEmployees = async () => {
    try {
      const { data } = await getEvents('', `teams-employees/${event.id}`);
      setTeamsEmployees(data);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  const handleInviteCustomers = async () => {
    setLoading(true);
    try {
      await createEvents(event, 'send-messages');
      message.success(t('Todos os convites foram enviados'));
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const getRowStyle = (status, response) => {
    if (status) {
      if (response === 0) return { backgroundColor: '#FFF4E6' };
      if (response === 1) return { backgroundColor: '#E6FFED' };
      if (response === 2) return { backgroundColor: '#FFEBEB' };
    }
    return {};
  };

  const getStatusIcon = (status) => {
    if (status === 'sent') return <LuCheck size={16} color="#888" />;
    if (status === 'delivered') return <LuCheck size={16} color="#888" />;
    if (status === 'read') return <LuCheckCheck size={16} color="#0A74DA" />;
    return <LuClock />;
  };

  useEffect(() => {
    let interval;
    if (visible) {
      fetchTeamsEmployees();
      interval = setInterval(() => {
        fetchTeamsEmployees();
      }, 2000);
    }
    return () => clearInterval(interval);
  }, [visible]);

  return (
    <Modal
      title={t('Convidar colaboradores') + (event?.name ? ` - ${event.name}` : '')}
      onCancel={onClose}
      open={visible}
      centered
      width="1000px"
      footer={<ModalFooter showOk={false} loading={loading} onCancel={onClose} />}
    >
      <Spin spinning={loading}>
        <Row style={{ marginBottom: 20 }}>
          <Button loading={loading} onClick={handleInviteCustomers}>
            <FaWhatsapp style={{ marginRight: 6 }} />
            {t('Convidar colaboradores')}
          </Button>
        </Row>
        {/* <Flex vertical style={{ marginBottom: 10 }}>
          {!event?.adress_street && (
            <Tag color="red">{t('Logradouro do evento é necessário para enviar o convite')}</Tag>
          )}
          {!event?.adress_number && (
            <Tag color="red">{t('Número do local do evento é necessário para enviar o convite')}</Tag>
          )}
          {!event?.adress_cep && <Tag color="red">{t('CEP do evento é necessário para enviar o convite')}</Tag>}
          {(!event?.city_name || !event?.state_name) && (
            <Tag color="red">{t('Cidade/Estado do evento é necessário para enviar o convite')}</Tag>
          )}
        </Flex> */}
        <Flex gap={25} align="center" justify="center" style={{ marginBottom: 10, flexWrap: 'wrap' }}>
          <Flex align="center" justify="center" gap={4}>
            <LuClock />
            <p>-</p>
            <Strong>{t('Não enviado')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <LuCheck />
            <p>-</p>
            <Strong>{t('Enviado')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <LuCheckCheck />
            <p>-</p>
            <Strong>{t('Entregue')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <LuCheckCheck color="#0A74DA" />
            <p>-</p>
            <Strong>{t('Lido')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: '#fdc882ff',
                border: '1px solid black',
              }}
            />
            <p>-</p>
            <Strong>{t('Não respondido')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: '#6bfa93ff',
                border: '1px solid black',
              }}
            />
            <p>-</p>
            <Strong>{t('Confirmado')}</Strong>
          </Flex>
          <Flex align="center" justify="center" gap={4}>
            <div
              style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: '#f76666ff',
                border: '1px solid black',
              }}
            />
            <p>-</p>
            <Strong>{t('Recusado')}</Strong>
          </Flex>
        </Flex>
        <SmallTable
          rowKey={(record) => record.employee_name + record.employee_phone}
          columns={inviteColumns(getStatusIcon)}
          dataSource={teamsEmployees.sort((a, b) => a.response - b.response)}
          pagination={false}
          size="small"
          onRow={(record) => ({
            style: getRowStyle(record.status, record.response),
          })}
        />
      </Spin>
    </Modal>
  );
}
